import { z } from 'zod';
export const recordAvailabilitySignalSchema = z.object({
    workerId: z.string().uuid(),
    loggedBy: z.string().nullable().optional(),
});
//# sourceMappingURL=availability-signal.js.map